//#region src/function/noop.ts
/** @internal */
function noop(..._args) {}
//#endregion
export { noop };

//# sourceMappingURL=noop.js.map